import { SHOW_NAV } from "./actionTypes";

export const showNav = (data) => {
  return {
    type: SHOW_NAV,
    payload: data,
  };
};
